import {collection} from "../../../models/collection";
import {NavLink, useNavigate} from "react-router-dom";
import React from "react";
import {useForm} from "react-hook-form";
import {ApiError, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";
import {Require} from "../Require";

type FormDataType = {
  label: string,
  enabled: boolean,
}

type CollectionFormProp = {
  collection?: collection
}

export const CollectionForm = ({collection}: CollectionFormProp) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    // watch,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      label: collection?.label,
      enabled: true,
      // enabled: collection?.enabled,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const apiData = {
      label: data.label,
      enabled: data.enabled,
    };

    try {
      collection
        ? await ApiService.patch(`/collection/${collection.collectionId}`, {param: () => apiData})
        : await ApiService.post('/collection', {param: () => apiData});

      navigate('/admin/equipment/collection');
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "label" | "enabled", {
          type: "manual",
          message: e.message
        })
      });
    }
  }

  return (
    <>
      <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex flex-wrap">
          <div className="col min-w400px max-w600px pe-4">
            {/*<div className="form-check form-switch mb-3">*/}
            {/*  <input className="form-check-input" type="checkbox" id="form-enabled" {...register('enabled')} />*/}
            {/*  <label className="form-check-label" htmlFor="form-enabled">*/}
            {/*    {`${watch('enabled') ? 'La collection est visible' : 'La collection n\'est pas visible'}`}*/}
            {/*  </label>*/}
            {/*</div>*/}

            <div className="mb-3">
              <label className="form-label" htmlFor="form-name">Nom <Require/></label>
              <input id="form-name" type="text" className="form-control" placeholder="~" {...register('label', {
                required: 'Le nom est obligatoire',
                validate: {
                  minLength: (value) =>
                    (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
                },
              })} />
              {errors.label && <p className="text-danger">{errors.label.message}</p>}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
          <NavLink to={`/admin/equipment/collection`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux collections</NavLink>
        </div>
      </form>
    </>
  )
}
